import React from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'

export default class Variable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false,
    }
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => this.props.value

  render() {
    const { touched, error, label } = this.props
    const classNames = {
      'formz-text-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <label className="formz-field-and-label-holder">
          <div style={{ background: 'transparent' }}>
            {label && <h3 className="formz-input-title">{label}</h3>}
          </div>
        </label>
      </FieldRowWrapper>
    )
  }
}
